// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"905":"0e9f591a","938":"48ce7b0b"}[chunkId] + ".chunk.css";
};